import React from 'react';
import Highcharts from 'highcharts';
import styled, { keyframes } from 'styled-components';
import { theme } from '../../../../theme/theme';
import { AreaSplineChart } from './AreaSplineChart';
import { Box } from '../../Box/Box';
import { Shimmer } from '../../Shimmer/Shimmer';
import { CURVE } from '../charts.constants';

const data = [
  {
    name: 'loading1',
    data: CURVE.map((y, x) => [x, y]),
  },
  {
    name: 'loading2',
    data: CURVE.map((y, x) => [x, y - 1]),
  },
];

const customSettings: Highcharts.Options = {
  series: [
    {
      color: theme.colors.neutral['50'],
      fillColor: theme.colors.neutral['50'],
      lineWidth: 0,
      type: 'areaspline',
    },
    {
      color: theme.colors.neutral['400'],
      fillColor: 'transparent',
      lineWidth: 2,
      type: 'areaspline',
    },
  ],

  tooltip: {
    enabled: false,
  },

  legend: {
    enabled: false,
  },

  yAxis: {
    gridLineWidth: 0,
  },

  plotOptions: {
    series: {
      animation: false,

      enableMouseTracking: false,

      accessibility: {
        enabled: false,
      },

      marker: {
        enabled: false,
      },

      states: {
        hover: { enabled: false },
      },
    },
  },
};

const dash = keyframes`
  to {
    stroke-dashoffset: 0;
    opacity: 0;
  }
`;

export const StyledChart = styled.div`
  position: relative;
  height: calc(100% - 48px);
  max-width: 950px;

  .highcharts-series-1 path {
    animation: ${dash} 3s ease infinite;
    stroke-dasharray: 1100;
    stroke-dashoffset: 1100;
    opacity: 1;
  }
`;

interface Props {
  containerProps?: Record<string, any>;
}

export const AreaSplineChartLoading = ({ containerProps }: Props) => {
  return (
    <StyledChart>
      <AreaSplineChart
        series={data}
        customSettings={customSettings}
        xAxisType="decimal"
        yAxisType="decimal"
        containerProps={containerProps}
      />

      <Box
        height={24}
        width="100%"
        display="flex"
        justifyContent="center"
        alignItems="center"
        mt="24"
      >
        <Shimmer height={24} width={120} mr="8" />
        <Shimmer height={24} width={120} ml="8" />
      </Box>
    </StyledChart>
  );
};
